import React from "react";
import { motion } from "framer-motion";
import { TermLabel } from "@/components/Effects";

// Standard page header for subpages — terminal label, display title, optional JP subtitle.
export default function PageHeader({ label, title, sub, jpTitle }) {
  return (
    <div className="relative mx-auto max-w-7xl px-4 pt-16 sm:px-6 sm:pt-20">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <TermLabel data-testid="page-header-label">{label}</TermLabel>
        <h1
          data-testid="page-header-title"
          className="mt-3 font-display text-3xl font-bold tracking-[0.12em] text-white sm:text-4xl lg:text-5xl"
        >
          {title}
        </h1>
        {jpTitle && (
          <div className="mt-2 font-jp text-sm tracking-[0.5em] text-mizu-cyan/70">
            {jpTitle}
          </div>
        )}
        {sub && (
          <p className="mt-4 max-w-2xl font-mono text-sm leading-7 text-mizu-dim">
            {sub}
          </p>
        )}
      </motion.div>
    </div>
  );
}
